import {Type} from 'main.core';

export class Compare
{
	constructor(options = {name: 'Compare'})
	{
		this.name = options.name;
		this.initEventListener()
	}

	initEventListener()
	{
		const instance = this

		$(document).on('click', '.js-compare-toggle', function(e){
			e.preventDefault()
			let el = $(this).parents('[data-element-id]');
			let id = el.data('element-id');
			if ($(this).hasClass('is-active')) {
				instance.delete(id);
			} else {
				instance.add(id);
			}
		})
	}

	add(id)
	{
		$.ajax({
			url: '/local/ajax/api/compare/',
			method: 'GET',
			data: {id: id, action: "ADD_TO_COMPARE_LIST"},
			success: function(e) {
				$('[data-element-id="'+id+'"]').find('.js-compare-toggle').addClass('is-active').addClass('click-active')
				$('.js-compare-count').html(e.COUNT)
			}
		})
	}

	delete(id)
	{
		$.ajax({
			url: '/local/ajax/api/compare/',
			method: 'GET',
			data: {id: id, action: "DELETE_FROM_COMPARE_LIST"},
			success: function(e) {
				$('[data-element-id="'+id+'"]').find('.js-compare-toggle').removeClass('is-active')
				$('.js-compare-count').html(e.COUNT)
			}
		})
	}

	getList(id)
	{
		$.ajax({
			url: '/local/ajax/api/compare/get.php',
			method: 'POST',
			data: {id: id},
			success: function(e) {
				e.forEach (function(item) {
					$('[data-element-id="'+item+'"]').find('.js-compare-toggle').addClass('is-active')
				})
				$('.js-compare-count').html(e.length)
			}
		})
	}

	setName(name)
	{
		if (Type.isString(name))
		{
			this.name = name;
		}
	}

	getName()
	{
		return this.name;
	}

}